<lib-cdw-role-edit
  #roleEdit
  *ngIf="!isLoading && (currentRole || selectedRoleId === 'new')"
  [rolePermissions]="currentRolePermissions"
  [role]="currentRole"
  (deleteRole)="onDeleteRoleEdit()"
  (cancelRoleEdit)="onCancelRoleEdit()"
  (submitRoleEdit)="onSubmitRoleEdit($event)"
  [permissions]="permissionSelectOptions"
></lib-cdw-role-edit>
